$(function () {
    /**
     * Sticky Page Nav
     */
    if ($("#page-nav").length) {
        console.log('id exists');

        //Get Header Height
        var mainHeader = $('#global-navigation');
        var mainHeaderHeight = $(mainHeader).height();

        //Get Page Nav Height
        var inPageNav = $('#page-nav');
        var inPageNavHeight = $(inPageNav).height();
        var inPageNavOffset = $(inPageNav).offset().top;

        //Highlight Active Section
        $('#page-nav a').on('click', function () {
            $("#page-nav li").removeClass('active');
            $(this).parent().addClass('active');
        });

        var stickyInPageNav = function () {
            var scrollTop = $(window).scrollTop();

            if (scrollTop > (inPageNavOffset - mainHeaderHeight - 10)) {
                $('#page-nav').addClass('active').css('top', mainHeaderHeight - 40);
            } else {
                $('#page-nav').removeClass('active');
            }


        };
        stickyInPageNav();

        $(window).scroll(function () {
            stickyInPageNav();



            /*
            var position = window.scrollY;
            $('.container').each(function () {
                var target = $(this).offset().top - headerHeight - 10;
                var id = $(this).attr('id');
    
                if (position >= target) {
                    $('#page-nav a').parent().removeClass('active');
                    $('#page-nav a[href="#' + id + '"]').parent().addClass('active');
                }
            });
            */
        });


    }
});